module.exports = __webpack_public_path__ + "static/img/img_howto2.e993b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_howto2.png
// module id = TT+D
// module chunks = 0